import { getFunctions } from "firebase/functions";
import { firebaseConfig } from "../config";
import { initializeApp } from "firebase/app";

export const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app);

export interface FunctionResponse {
  status: string;
}
